export const ShieldIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M6.4 16C4.54667 15.5333 3.01667 14.47 1.81 12.81C0.603333 11.15 0 9.30667 0 7.28V2.4L6.4 0L12.8 2.4V7.28C12.8 9.30667 12.1967 11.15 10.99 12.81C9.78333 14.47 8.25333 15.5333 6.4 16ZM6.4 14.32C7.78667 13.88 8.93333 13 9.84 11.68C10.7467 10.36 11.2 8.89333 11.2 7.28V3.5L6.4 1.7L1.6 3.5V7.28C1.6 8.89333 2.05333 10.36 2.96 11.68C3.86667 13 5.01333 13.88 6.4 14.32Z" />
    </svg>
  );
};
